<template>
	<div class="all_main">
		<myheader headTitle="设置"></myheader>
		<div v-if="!homeUrl" class="all_height_line24 backgroundC_white display_flex bwhite_ative"
			@click="toChangePassword()">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">重设登录密码</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div>
		<div v-if="!homeUrl" class="all_height_line24 margin_top_10 backgroundC_white display_flex bwhite_ative"
			@click="toChangeMobile()">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">更换手机号码</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div>
		<div v-if="!homeUrl" class="all_height_line24 margin_top_10 backgroundC_white display_flex bwhite_ative"
			@click="toNotifyClick()">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">通知设置</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div>
		<div v-if="!homeUrl" class="all_height_line24 margin_top_10 backgroundC_white display_flex bwhite_ative"
			@click="toLogOffClick()">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">注销账号</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div>
		<div v-if="homeUrl" class="all_height_line24 margin_top_10 backgroundC_white display_flex bwhite_ative"
			@click="agreementPrivacyClick()">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">隐私政策声明</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div>
		<!-- <div v-if="homeUrl" class="all_height_line24 backgroundC_white display_flex bwhite_ative"
			@click="agreementUserClick()">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">服务协议</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div> -->
		<div v-if="homeUrl" class="all_height_line24 margin_top_10 backgroundC_white display_flex bwhite_ative"
			@click="aboutClick()">
			<span class="text14 textcolor333 all_line_height24 display_inline_block"
				style="width: 90%;padding-left: .8rem;">关于</span>
			<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
		</div>
		<div v-if="!homeUrl" id="reload" @click="onReload"
			class="text14 textcolormain all_height_line24 margin_top_10 backgroundC_white all_text_center bwhite_ative">
			清除缓存
		</div>
		<div class="text14 textcolor333 all_height_line24 margin_top_10 backgroundC_white all_text_center bwhite_ative"
			style="color:#DF4545" @click="logout()">
			退出登录
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		Dialog
	} from 'vant';
	import {
		resetRouter
	} from '../../router/index.js'
	import {
		getDeviceType,
	} from '../../utils/nativeOtherOperate.js'
	export default {
		data() {
			return {
				homeUrl: '',
				//
				isEsign: process.env.VUE_APP_PROJECT_OWNER === 'esign',
			};
		},
		mounted() {
			this.homeUrl = window.localStorage.getItem("HomeUrl")
			// document.addEventListener('UniAppJSBridgeReady', function(event) {
			// 	console.log('UniAppJSBridgeReady',event)
			// 	document.getElementById('reload').addEventListener('click', function() {
			// 		console.log('UniAppJSBridgeReady',event)
			// 		uni.postMessage({
			// 			data: {
			// 				action: 'message'
			// 			}
			// 		});
			// 	})
			// })
			//发送消息到uniapp中刷新加载
			// document.getElementById('reload').addEventListener('click', function() {
			// 	console.log('UniAppJSBridgeReady', event)
			// 	//window.sessionStorage.setItem('event', 0)
			// 	this.$store.commit("changeReLogin", '1')
			// 	uni.postMessage({
			// 		data: {
			// 			action: 'message'
			// 		}
			// 	});
			// })
		},
		methods: {
			//
			onReload() {
				let that = this
				switch (getDeviceType()) {
					case 'android':
					case 'ios':
						this.$store.commit("changeReLogin", '1')
						that.$router.push({
							path: '/home',
							query: {
								t: Date.now()
							}
						})
						break;
					case 'harmony':
						harmonyEsign.reStartApp()
						break;
				}
			},
			//
			toChangePassword() {
				this.$router.push({
					path: '/changepassword'
				})
			},
			//修改手机号
			toChangeMobile() {
				this.$router.push({
					path: '/changemobile'
				})
			},
			//通知设置
			toNotifyClick() {
				this.$router.push({
					path: '/notifysettings',
				})
			},
			//注销账户
			toLogOffClick() {
				this.$router.push({
					path: '/accountlogoff',
				})
				return
				// Dialog.confirm({
				// 		title: '提示',
				// 		message: '确定退出注销登录用户？',
				// 		confirmButtonText: '确定',
				// 		confirmButtonColor: '#0277FC'
				// 	})
				// 	.then(() => {
				// 	}).catch((err) => {
				// 		//取消
				// 	});
			},
			//关于
			aboutClick() {
				this.$router.push({
					path: '/about',
				})
			},
			//用户协议
			agreementUserClick() {
				this.$router.push({
					name: 'agreementdetails',
					params: {
						type: 1,
					}
				})
			},
			//隐私政策
			agreementPrivacyClick() {
				let names = 'agreementdetails'
				if (!this.isEsign) {
					names = 'agreement'
				}
				this.$router.push({
					name: names,
					params: {
						type: 2,
					}
				})
			},
			//退出登录
			logout() {
				Dialog.confirm({
						title: '提示',
						message: '确定退出当前登录用户？',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						this.$store.dispatch(this.$LoadShow, true)
						this.$post(
							'/my/api/logoff',
						).then((res) => {
							this.$store.dispatch(this.$LoadShow, false)
							if (res.success) {
								this.logoutSuccess()
							} else {
								this.$Toast(res.message || res.messageDetail || "请求失败，请重试！");
								this.logoutSuccess()
							}
						}).catch((err) => {
							this.$store.dispatch(this.$LoadShow, false)
							this.logoutSuccess()
							console.log('logoff', err)
						});
					}).catch((err) => {
						//取消
					});
			},
			//
			logoutSuccess() {
				//清缓存
				if (window.plus && plus.os.name === 'Android') {
					plus.cache.clear()
				} else if (window.plus && plus.os.name === 'iOS') {
					let cache1 = plus.ios.newObject('NSURLCache')
					let cache = plus.ios.invoke(cache1, 'sharedURLCache')
					plus.ios.invoke(cache, 'removeAllCachedResponses')
					plus.ios.invoke(cache, 'setDiskCapacity:', 1)
					plus.ios.invoke(cache, 'setMemoryCapacity:', 0)
				}
				//console.log('-----退出成功-----')
				window.localStorage.setItem("LoginInfo", '')
				window.localStorage.setItem("Identity_Token", '')
				window.localStorage.setItem("HomeUrl", '')
				this.$store.commit("changeLoginInfo", '')
				this.$store.commit("changeLoginToken", '')
				this.$store.dispatch("actionUserInfo", '');
				this.$store.commit("changeHomeUrl", '')
				resetRouter()
				this.$Toast("退出成功，请重新登录！");
				this.$router.push('/login')
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>